import { Link } from "react-router-dom";
import type { Scoop } from "@/mocks/types";
import { verdictMeta } from "@/mocks/types";
import CredibilityMeter from "@/components/base/CredibilityMeter";
import VerdictBadge from "@/components/base/VerdictBadge";

interface SidePanelProps {
  scoop: Scoop;
}

const tocItems = [
  { id: "article-body", label: "求证正文" },
  { id: "article-evidence", label: "证据清单" },
  { id: "article-timeline", label: "事件时间线" },
  { id: "article-related", label: "相关档案" },
];

export default function SidePanel({ scoop }: SidePanelProps) {
  return (
    <aside className="lg:sticky lg:top-6 space-y-4">
      <div className="rounded-lg border border-background-200 bg-background-50 p-5">
        <div className="flex items-center justify-between">
          <span className="font-label text-[11px] uppercase tracking-widest text-foreground-500">求证结论</span>
          <VerdictBadge verdict={scoop.verdict} size="sm" />
        </div>
        <p className="mt-3 text-[13px] leading-relaxed text-foreground-600">{verdictMeta[scoop.verdict].desc}</p>
        <div className="mt-5">
          <CredibilityMeter value={scoop.credibility} />
        </div>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-50 p-5">
        <dl className="space-y-3 text-[13px]">
          <div className="flex items-center justify-between">
            <dt className="text-foreground-500">档案编号</dt>
            <dd className="font-label text-foreground-900">{scoop.code.replace("档案号 ", "")}</dd>
          </div>
          <div className="flex items-center justify-between">
            <dt className="text-foreground-500">所属领域</dt>
            <dd className="text-foreground-900">{scoop.category}</dd>
          </div>
          <div className="flex items-center justify-between">
            <dt className="text-foreground-500">独立来源</dt>
            <dd className="font-label text-foreground-900">{scoop.sources} 个</dd>
          </div>
          <div className="flex items-center justify-between">
            <dt className="text-foreground-500">登记材料</dt>
            <dd className="font-label text-foreground-900">{scoop.evidence.length} 份</dd>
          </div>
          <div className="flex items-center justify-between">
            <dt className="text-foreground-500">首次发布</dt>
            <dd className="font-label text-foreground-900">{scoop.date}</dd>
          </div>
          <div className="flex items-center justify-between">
            <dt className="text-foreground-500">最近更新</dt>
            <dd className="font-label text-foreground-900">{scoop.updated.slice(5)}</dd>
          </div>
        </dl>
      </div>

      <nav aria-label="本页目录" className="rounded-lg border border-background-200 bg-background-50 p-5">
        <h3 className="font-label text-[11px] uppercase tracking-widest text-foreground-500">本页目录</h3>
        <ul className="mt-3 space-y-1">
          {tocItems.map((item) => (
            <li key={item.id}>
              <a
                href={`#${item.id}`}
                className="flex items-center gap-2 rounded-md px-2 py-1.5 text-[13px] text-foreground-600 transition-colors hover:bg-background-100 hover:text-primary-600"
              >
                <span className="h-1 w-1 rounded-full bg-background-400" aria-hidden="true"></span>
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      </nav>

      <div className="rounded-lg border border-accent-300 bg-accent-50 p-5">
        <h3 className="font-heading text-sm font-bold text-accent-900">你也掌握相关材料？</h3>
        <p className="mt-2 text-[13px] leading-relaxed text-accent-800">
          欢迎补充原始材料或指出档案中的错误，我们会公开说明核实结果。
        </p>
        <Link
          to="/contact"
          className="mt-4 inline-flex w-full items-center justify-center gap-2 rounded-md bg-accent-500 px-4 py-2.5 text-sm font-medium text-foreground-950 transition-colors hover:bg-accent-600 whitespace-nowrap"
        >
          <i className="ri-send-plane-line" aria-hidden="true"></i>
          提供线索 / 纠错
        </Link>
      </div>
    </aside>
  );
}